import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import {
    Badge,
    Row,
    Col,
    Tooltip,
    Tag,
    Button,
    Progress,
    Avatar,
    Input,
    Card,
    Rate,
    Icon,
    Dropdown,
    Menu,
} from 'antd'
import moment from 'moment'
import Comments from '../../../../componentIsoMophic//ScrumBoard/Comments/Comments'
import HeadingWithIcon from '../../../../componentIsoMophic/ScrumBoard/HeadingWithIcon/HeadingWithIcon'
import { IconSvg } from '../../../../componentIsoMophic/ScrumBoard/IconSvg/IconSvg'
import CardDetailsHeader from './TaskDetailsHeader'
import {
    CardDetailsWrapper,
    AttachmentWrapper,
    TaskName,
    TaskDescription,
    ClockIcon,
} from '../Task.style'
import PlusIcon from '../../../assets/images/icon/24.svg'
import TitleIcon from '../../../assets/images/icon/05-icon.svg'
import DescriptionIcon from '../../../assets/images/icon/06-icon.svg'
import AttachmentIcon from '../../../assets/images/icon/01-icon.svg'
import Clock from '../../../assets/images/icon/17.svg'
import scrumBoardActions from '../../../../redux/scrumBoard/actions'
import objectAction from '../../../../redux/object/actions'
import mediaAction from '../../../../redux/qbmedia/actions'
import Plus from '../../../assets/images/icon/24.svg'
import ReactQuill, { Quill } from 'react-quill'
import { saveAs } from 'file-saver'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import htmlDocx from 'html-docx-js/dist/html-docx'
import { MdAssignment, MdViewModule } from 'react-icons/md'
import { IoIosPaperPlane, IoMdPerson } from 'react-icons/io'
import { FaCalendarCheck } from 'react-icons/fa'
import defaultImgEvent from '../../../../resource/image/imgEventDefaul.jpg'
import objectDefault from '../../../../resource/image/objectDefault.png'
const default_avatar = require('../../../../resource/image/defaultUser.png')

const { TextArea } = Input

const TaskDetials = ({
    task,
    deleteTask,
    editTask,
    closeDrawer,
    openDrawer,
    columnId,
    currentListOrg,
    getListMediaQueryById,
    getListObjectQueryById,
    currentListObject,
    currentListMedia,
    organizations,
    selected_Media,
    getListMediaQueryByIdDone,
    ListCurrentObject,
    ListCurrentEvent,
    getListCurrentEvent,
    getListObjectQueryById_done,
    getListCurrentEventDone,
    updateScoreReport,
    getDetailTaskById,
    getListRanking,
    getListRankingDone,
    listRanking,
    userInfo,
    currentBoard,
    ListCurrentMedia,
    getListCurrentUser,
    lstCurrentUser
}) => {
    console.log('task data detail', task)
    console.log('list ranking', organizations)
    useEffect(() => {
        //cho phan report
        if (task.type === 'report') {
            if (task.media) {
                getListMediaQueryById(task.media.toString())
            }
            if (task.object) {
                getListObjectQueryById(task.object.toString())
            }
            if (task.event) {
                getListCurrentEvent(task.event.toString())
            }
        } else {
            // cho phan thong tin
            if (task.lst_media) {
                getListMediaQueryById(task.lst_media.toString())
            }
            if (task.lst_object_id) {
                getListObjectQueryById(task.lst_object_id.toString())
            }
            if (task.lst_event_id) {
                getListCurrentEvent(task.lst_event_id.toString())
            }
            if (task.IdOfTask) {
                getListRanking(task.IdOfTask)
            }
            if(task.lst_uid_receive){
                getListCurrentUser(task.lst_uid_receive)
            }
        }

        return () => {
            getListMediaQueryByIdDone([])
            getListObjectQueryById_done([])
            getListCurrentEventDone([])
            getListRankingDone([])
            getDetailTaskById(task.IdOfTask)
        }
    }, [getListMediaQueryById, getListObjectQueryById])

    const menu = (
        <Menu>
            <Menu.Item key="1" onClick={() => printDocument()}>
                Xuất ra định dạng pdf
            </Menu.Item>
            <Menu.Item key="2" onClick={() => exportToDocs(task.description)}>
                Xuất ra định dạng docx
            </Menu.Item>
        </Menu>
    )
    const quillModules = {
        toolbar: false,
    }
    const getRandomInt = max => {
        return Math.floor(Math.random() * Math.floor(max))
    }
    const onChangeRate = value => {
        updateScoreReport(task.id, value)
    }
    const getColorTag = () => {
        const color = [
            'magenta',
            'red',
            'volcano',
            'orange',
            'gold',
            'lime',
            'green',
            'cyan',
            'blue',
            'geekblue',
            'purple',
        ]
        const index = getRandomInt(color.length)

        return color[index]
    }
    const exportToDocs = content => {
        let html = `<!DOCTYPE html>
        <html>
        <head>
        <meta charset="UTF-8">
        
        </head>
        <body>
        ${content}
        </body>
        </html>`
        const docx = htmlDocx.asBlob(html, {
            orientation: 'landscape',
            margins: { top: 720, right: 2000 },
        })
        saveAs(docx, 'download.docx')
    }
    const printDocument = () => {
        const input = document.getElementById('divToPrint')
        html2canvas(input).then(canvas => {
            const imgData = canvas.toDataURL('image/png')
            var imgWidth = 210
            var pageHeight = 295
            var imgHeight = (canvas.height * imgWidth) / canvas.width
            var heightLeft = imgHeight

            const pdf = jsPDF('p', 'mm', 'a4', true)
            var position = 3
            pdf.addImage(imgData, 'PNG', 5, position, imgWidth, imgHeight)
            heightLeft -= pageHeight
            while (heightLeft >= 0) {
                position = heightLeft - imgHeight
                pdf.addPage()
                pdf.addImage(imgData, 'PNG', 5, position, imgWidth, imgHeight)
                heightLeft -= pageHeight
            }

            pdf.save('download.pdf')
        })
    }
    const getCurrentOrgById = id => {
        const curOrg = organizations.find(org => {
            return org.oid === id
        })
        return curOrg
    }
    console.log('currentListOrg', currentListOrg)
    return (
        <CardDetailsWrapper>
            <CardDetailsHeader
                taskType={task.type}
                // canEdit={task.canEdit && userInfo.uid === task.owner_id}
                canEdit={task.canEdit}
                currentBoard={currentBoard}
                onBtnClick={() => {
                    openDrawer({
                        drawerType: 'CREATE_OR_EDIT_TASK',
                        drawerProps: {
                            initials: {
                                ...task,
                                editing: true,
                                currentListOrg,
                                organizations,
                            },
                            columnId: columnId,
                        },
                    })
                }}
                OnBtnEditTaskClick={() => {
                    openDrawer({
                        drawerType: 'CREATE_OR_EDIT_REPORT',
                        drawerProps: {
                            columnId: columnId,
                            idOfBoard: task.id,
                            initials: {
                                ...task,
                                editing: true,
                                currentListOrg,
                                organizations,
                            },
                        },
                    })
                }}
                onIconClick={closeDrawer}
            />
            <div
                style={{
                    borderWidth: 1,
                    borderColor: '#e9e9e9',
                }}
            >
                <HeadingWithIcon
                    heading={
                        task.type === 'require'
                            ? 'Tên nhiệm vụ *'
                            : 'Tên báo cáo *'
                    }
                    iconSrc={TitleIcon}
                />
                <TaskName>{task.title}</TaskName>
            </div>
            <Row gutter={16} style={{ paddingTop: 10 }}>
                {(task.type === 'require' || task.type === 'report') && (
                    <Col md={6}>
                        <HeadingWithIcon heading="Đơn vị thực hiện" />
                        <p>
                            {task.type === 'require' &&
                                currentListOrg &&
                                currentListOrg.map(org => (
                                    <Tooltip
                                        title={org.name}
                                        placement="bottom"
                                        key={Tooltip}
                                    >
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href={`/app/organization-management/${org.oid}`}
                                        >
                                            <IconSvg
                                                src={org.ext_data.avatarOrgani}
                                                padding={'0'}
                                                radius={'10% 30% 25%'}
                                            />
                                        </a>
                                    </Tooltip>
                                ))}
                            {task.type === 'report' &&
                                currentListOrg &&
                                currentListOrg.map(org => {
                                    if (task.organ_create === org.oid) {
                                        return (
                                            <Tooltip
                                                title={org.name}
                                                placement="bottom"
                                                key={Tooltip}
                                            >
                                                <a
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    href={`/app/organization-management/${org.oid}`}
                                                >
                                                    <IconSvg
                                                        src={
                                                            org.ext_data
                                                                .avatarOrgani
                                                        }
                                                        padding={'0'}
                                                        radius={'10% 30% 25%'}
                                                    />
                                                </a>
                                            </Tooltip>
                                        )
                                    }
                                })}
                        </p>
                    </Col>
                )}
                {task.type === 'require' && (
                    <Col md={6}>
                        <HeadingWithIcon heading="Cá nhân tham gia" />
                        {task.type === 'require' &&
                                lstCurrentUser &&
                                lstCurrentUser.map(user => (
                                    <Tooltip
                                        title={user.display_name}
                                        placement="bottom"
                                        key={Tooltip}
                                    >
                                        <a
                                            // target="_blank"
                                            // rel="noopener noreferrer"
                                            // href={`/app/organization-management/${user.uid}`}
                                        >
                                            <IconSvg
                                                src={user.avatar === '' ? default_avatar : user.avatar}
                                                padding={'0'}
                                                radius={'10% 30% 25%'}
                                            />
                                        </a>
                                    </Tooltip>
                                ))}
                    </Col>
                )}

                <Col md={6}>
                    <HeadingWithIcon heading="HashTag" />
                    <p>
                        {task.labels.map(label => (
                            <Tooltip
                                title={`${label[0].toUpperCase()}${label.slice(
                                    1
                                )}`}
                                placement="bottom"
                                key={label}
                            >
                                <Tag color={getColorTag()}>{label}</Tag>
                            </Tooltip>
                        ))}
                    </p>
                </Col>
                {task.due_date !== null && (
                    <Col md={6}>
                        <HeadingWithIcon heading="Ngày kết thúc" />
                        <ClockIcon src={Clock} />
                        {moment(task.due_date * 1000).format('DD/MM/YYYY')}
                    </Col>
                )}
            </Row>
            <Row gutter={16} style={{ paddingTop: 10 }}>
                <Col md={8}>
                    <HeadingWithIcon
                        icon={
                            <MdAssignment
                                style={{
                                    paddingRight: 4,
                                    height: 20,
                                    width: 20,
                                }}
                            />
                        }
                        heading={`Tài liệu liên quan `}
                    />
                    {ListCurrentMedia.map(media => (
                        <Button
                            type="link"
                            // href={media.url}
                            target="_blank"
                            onClick={() => {
                                window.open(media.url, '_blank')
                            }}
                            block={false}
                            style={{ paddingLeft: 5 }}
                        >
                            {media.name}
                        </Button>
                    ))}
                </Col>
            </Row>
            <Row gutter={16} style={{ paddingTop: 10 }}>
                <Col md={12}>
                    <HeadingWithIcon
                        icon={
                            <IoIosPaperPlane
                                style={{
                                    paddingRight: 4,
                                    height: 20,
                                    width: 20,
                                }}
                            />
                        }
                        heading={`Đối tượng liên quan `}
                    />
                    {ListCurrentObject.map(object => (
                        <Tooltip
                            title={object.name}
                            placement="bottom"
                            key={object}
                        >
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={`/app/qbobjects/${object.object_id}`}
                            >
                                <Avatar
                                    shape="square"
                                    size={64}
                                    src={
                                        object.avatar === ''
                                            ? objectDefault
                                            : object.avatar
                                    }
                                    style={{ margin: 10 }}
                                />
                            </a>
                        </Tooltip>
                    ))}
                </Col>
                <Col md={12}>
                    <HeadingWithIcon
                        icon={
                            <FaCalendarCheck
                                style={{
                                    paddingRight: 4,
                                    height: 18,
                                    width: 18,
                                }}
                            />
                        }
                        heading={`Sự kiện liên quan `}
                    />
                    {ListCurrentEvent.map(event => (
                        <Tooltip
                            title={event.name}
                            placement="bottom"
                            key={event}
                        >
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={`/app/qbevents/${event.event_id}`}
                            >
                                <Avatar
                                    shape="square"
                                    size={64}
                                    src={
                                        event.avatar === ''
                                            ? defaultImgEvent
                                            : event.avatar
                                    }
                                    style={{ margin: 10 }}
                                />
                            </a>
                        </Tooltip>
                    ))}
                </Col>
            </Row>
            <Row gutter={16} style={{ paddingTop: 10 }}>
                {task.type === 'require' && (
                    <Col md={12}>
                        <HeadingWithIcon
                            icon={
                                <MdViewModule
                                    style={{
                                        paddingRight: 4,
                                        height: 20,
                                        width: 20,
                                    }}
                                />
                            }
                            heading={`Tiến độ hoàn thành `}
                        />
                        <Progress
                            strokeLinecap="square"
                            type="circle"
                            percent={task.process}
                        />
                    </Col>
                )}
                <Col md={12}>
                    {task.type === 'require' && (
                        <div>
                            <HeadingWithIcon
                                icon={
                                    <IoMdPerson
                                        style={{
                                            paddingRight: 4,
                                            height: 20,
                                            width: 20,
                                        }}
                                    />
                                }
                                heading="Đánh giá chất lượng"
                            />
                            {listRanking.map(rank => {
                                const dataOrg = getCurrentOrgById(rank.id)
                                console.log('data org', dataOrg)
                                if (dataOrg) {
                                    return (
                                        <div style={{ padding: 5 }}>
                                            <Tooltip
                                                title={dataOrg.name}
                                                placement="bottom"
                                                key={Tooltip}
                                            >
                                                <IconSvg
                                                    src={
                                                        dataOrg.ext_data
                                                            .avatarOrgani
                                                    }
                                                    padding={'0'}
                                                    radius={'10% 30% 25%'}
                                                />
                                            </Tooltip>
                                            <Rate
                                                allowHalf
                                                disabled
                                                defaultValue={rank.score}
                                            />
                                        </div>
                                    )
                                }
                            })}
                        </div>
                    )}
                </Col>
            </Row>

            {task.type === 'require' && (
                <HeadingWithIcon
                    heading="Yêu cầu *"
                    iconSrc={DescriptionIcon}
                />
            )}

            {task.type === 'require' && (
                <TextArea
                    placeholder="Yêu cầu *"
                    autosize={{ minRows: 8 }}
                    disabled={true}
                    style={{ color: 'black' }}
                >
                    {task.description}
                </TextArea>
            )}

            {task.type === 'report' && (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingRight: 30,
                    }}
                >
                    <HeadingWithIcon
                        heading="Nội dung báo cáo *"
                        iconSrc={DescriptionIcon}
                    />
                    <Dropdown overlay={menu}>
                        <Button>
                            Xuất ra file <Icon type="down" />
                        </Button>
                    </Dropdown>
                </div>
            )}
            {task.type === 'report' && (
                <ReactQuill
                    style={{
                        width: '100%',
                        height: '100%',
                        paddingRight: 30,
                    }}
                    id="divToPrint"
                    modules={quillModules}
                    readOnly
                    value={task.description + `<p><br></p><p><br></p>`}
                />
            )}

            {task.type === 'report' && (
                <div
                    style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                        display: 'flex',
                        width: '100%',
                        height: '100%',
                        padding: 20,
                    }}
                >
                    <Rate
                        disabled={
                            userInfo.uid !== task.owner_id &&
                            userInfo.tier_id !== 100
                        }
                        defaultValue={task.score}
                        onChange={value => onChangeRate(value)}
                    />{' '}
                    <div>Đánh giá nhiệm vụ</div>
                </div>
            )}

            {task.type === 'report' && <HeadingWithIcon heading="Bình luận" />}
            {task.type === 'report' && <Comments rid={task.id} />}
        </CardDetailsWrapper>
    )
}
export default connect(
    (state, ownProps) => {
        console.log('state.qbmedia', state.qbmedia.currentListMedia)
        return {
            currentListOrg: state.organization.currentListOrg,
            currentListObject: state.object.currentListObject,
            organizations: state.organization.organizations,
            ListCurrentMedia: state.scrumBoard.ListCurrentMedia,
            ListCurrentObject: state.scrumBoard.ListCurrentObject,
            ListCurrentEvent: state.scrumBoard.ListCurrentEvent,
            listRanking: state.scrumBoard.listRanking,
            listAllOrg: state.organization.listAllOrg,
            userInfo: state.auth.userInfo,
            currentBoard: state.scrumBoard.currentBoard,
            lstCurrentUser: state.scrumBoard.lstCurrentUser,

        }
    },
    { ...scrumBoardActions, ...objectAction.action, ...mediaAction.action }
)(TaskDetials)
